<template>
  <v-dialog
    :value="visible"
    persistent
    :max-width="600"
    :fullscreen="$vuetify.breakpoint.mobile"
    :scrollable="$vuetify.breakpoint.mobile"
  >
    <v-card>
      <v-card-title>
        <app-title size="normal" weight="bold">{{ $t('dialogMetadata.consent.title') }}</app-title>
      </v-card-title>

      <v-card-text class="position-relative" :class="{'pt-2': $vuetify.breakpoint.mobile}">
        <div>{{ $t('dialogMetadata.consent.udpateLegalInfo') }}</div>

        <div class="mt-4">
          {{ session }}
        </div>

        <div class="mt-4">{{ $t('dialogMetadata.consent.exitText') }}</div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn outlined @click.prevent="visible = false">{{ $t('buttons.clear') }}</v-btn>

        <v-btn outlined @click="$emit('logout')">
          {{ $t('buttons.exit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {formatRemains} from './formatRemains.js';

const INTERVAL_MS = 3600000;

export default {
  name: 'ConsentDialog',
  props: {
    url: {type: String, default: '/consent/check'},
  },
  data() {
    return {
      visible: false,
      remainsSeconds: 0,
      countdownTimerId: null,
    };
  },
  computed: {
    session() {
      const remains = formatRemains(this.$i18n, this.remainsSeconds);
      return this.$t('dialogMetadata.consent.session', {remains});
    },
  },
  mounted() {
    this._stopped = false;
    this._timerId = null;
    this._inFlight = false;
    this.tick();
  },
  beforeDestroy() {
    this._stopped = true;
    if (this._timerId) {
      clearTimeout(this._timerId);
      this._timerId = null;
    }
    this.stopCountdown();
  },
  methods: {
    startCountdown() {
      this.stopCountdown();
      this.countdownTimerId = setInterval(() => {
        if (this.remainsSeconds > 0) {
          this.remainsSeconds--;
        } else {
          this.stopCountdown();
          this.$emit('logout');
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.countdownTimerId) {
        clearInterval(this.countdownTimerId);
        this.countdownTimerId = null;
      }
    },
    async tick() {
      if (this._stopped || this._inFlight) return;
      this._inFlight = true;
      try {
        const resp = await fetch(this.url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {'Content-Type': 'application/json'},
          body: '',
        });
        if (resp.status === 401) {
          this._stopped = true;
          return;
        }
        if (!resp.ok) return;
        const data = await resp.json();

        if (data.expired) {
          window.location.reload();
          return;
        }
        if (data.consent) {
          this.visible = false;
          this.stopCountdown();
        } else {
          this.remainsSeconds = Number(data.remains_seconds) || 0;
          this.visible = true;
          this.startCountdown();
        }
      } catch (e) {
        // network error — ignore, retry next tick
      } finally {
        this._inFlight = false;
        if (!this._stopped) {
          this._timerId = setTimeout(() => this.tick(), INTERVAL_MS);
        }
      }
    },
  },
};
</script>
